/*
 * @Author: 黎肖
 * @Description: 导出eb开发的eb组件
 */

export { default as LoginCom } from './login';

export default {};